import { call, put, takeEvery, fork } from "redux-saga/effects";
import * as actions from "../actions/cuentacorriente";
import cuentacorriente from "../services/cuentacorriente";

function* getByFacturaId({ clienteId, facturaId }) {
  yield put(actions.startLoading());
  try {
    const response = yield call(
      cuentacorriente.getByFacturaId,
      clienteId,
      facturaId,
    );
    if (response) {
      yield put(actions.getEstadoPedidoByPresupuestoIdSucceeded(response));
    }
  } catch (err) {
    yield put(actions.getEstadoPedidoByPresupuestoIdError(err));
    console.log(err);
  }
}

function* getEstadoPedidosByFilter({ filter }) {
  yield put(actions.startLoading());
  try {
    const response = yield call(
      cuentacorriente.getEstadoPedidosByFilter,
      filter,
    );
    if (response) {
      yield put(actions.getEstadoPedidoByFilterSucceeded(response));
    }
  } catch (err) {
    yield put(actions.getEstadoPedidoByFilterError(err));
    console.log(err);
  }
}

function* getSaldosByFilter({ filter }) {
  yield put(actions.startLoading());
  try {
    const response = yield call(cuentacorriente.getSaldosByFilter, filter);
    if (response) {
      yield put(actions.getSaldosByFilterSucceeded(response));
    }
  } catch (err) {
    yield put(actions.getSaldosByFilterError(err));
    console.log(err);
  }
}

function* getComposicionByFilter({ filter }) {
  yield put(actions.startLoading());
  try {
    const response = yield call(cuentacorriente.getComposicionByFilter, filter);
    if (response) {
      yield put(actions.getComposicionByFilterSucceeded(response));
    }
  } catch (err) {
    yield put(actions.getComposicionByFilterError(err));
    console.log(err);
  }
}

function* getFacturasByFilter({ filter }) {
  yield put(actions.startLoading());
  try {
    const response = yield call(cuentacorriente.getFacturasByFilter, filter);
    if (response) {
      yield put(actions.getFacturasByFilterSucceeded(response));
    }
  } catch (err) {
    yield put(actions.getFacturasByFilterError(err));
    console.log(err);
  }
}

function* getEstados() {
  yield put(actions.startLoading());
  try {
    const response = yield call(cuentacorriente.getEstados);
    if (response) {
      yield put(actions.getEstadosSucceeded(response));
    }
  } catch (err) {
    yield put(actions.getEstadosError(err));
    console.log(err);
  }
}

function* getTiposDocumento() {
  yield put(actions.startLoading());
  try {
    const response = yield call(cuentacorriente.getTiposDocumento);
    if (response) {
      yield put(actions.getTiposDocumentoSucceeded(response));
    }
  } catch (err) {
    yield put(actions.getTiposDocumentoError(err));
    console.log(err);
  }
}

function* getEstadoTitulo() {
  yield put(actions.startLoading());
  try {
    const response = yield call(cuentacorriente.getEstadoTitulo);
    if (response) {
      yield put(actions.getEstadoTituloSucceeded(response));
    }
  } catch (err) {
    yield put(actions.getEstadoTituloError(err));
    console.log(err);
  }
}

function* watchGetByFacturaId() {
  yield takeEvery(
    actions.Types.ESTADO_PEDIDO_PRESUPUESTO_GET_REQUEST,
    getByFacturaId,
  );
}
function* watchGetEstadoPedidosByFilter() {
  yield takeEvery(
    actions.Types.ESTADO_PEDIDO_FILTER_GET_REQUEST,
    getEstadoPedidosByFilter,
  );
}
function* watchGetSaldosByFilter() {
  yield takeEvery(actions.Types.SALDOS_FILTER_GET_REQUEST, getSaldosByFilter);
}
function* watchGetComposicionByFilter() {
  yield takeEvery(
    actions.Types.COMPOSICION_FILTER_GET_REQUEST,
    getComposicionByFilter,
  );
}
function* watchGetFacturasByFilter() {
  yield takeEvery(
    actions.Types.FACTURA_FILTER_GET_REQUEST,
    getFacturasByFilter,
  );
}
function* watchGetEstados() {
  yield takeEvery(actions.Types.ESTADOS_GET_REQUEST, getEstados);
}
function* watchGetTiposDocumento() {
  yield takeEvery(actions.Types.TIPO_DOCUMENTOS_GET_REQUEST, getTiposDocumento);
}
function* watchGetEstadoTitulo() {
  yield takeEvery(actions.Types.ESTADO_TITULO_GET_REQUEST, getEstadoTitulo);
}

const cuentacorrienteSagas = [
  fork(watchGetByFacturaId),
  fork(watchGetEstadoPedidosByFilter),
  fork(watchGetSaldosByFilter),
  fork(watchGetComposicionByFilter),
  fork(watchGetFacturasByFilter),
  fork(watchGetEstados),
  fork(watchGetTiposDocumento),
  fork(watchGetEstadoTitulo),
];

export default cuentacorrienteSagas;
